import React from "react";
import { motion } from "framer-motion";

// Multicolor embroidered wordmark: covertswag
const MAP = ["stitch-r", "stitch-b", "stitch-y", "stitch-g"];

export const Wordmark = ({ text = "covertswag", className = "" }) => (
  <span className={`wordmark ${className}`} aria-label={text}>
    {text.split("").map((c, i) => (
      <span key={i} className={MAP[i % 4]}>{c}</span>
    ))}
  </span>
);

// Masked line-by-line reveal
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-mask">
    <motion.span
      className={`inline-block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

// Scroll reveal wrapper
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);
